/**
 * Ryan O'Dowd
 * 2024-02-27
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors, isDarkMode}) => {
  return {
    activeGoalOption: {
      marginVertical: 4,
      padding: 8,
      backgroundColor: isDarkMode ? colors.primaryDark : colors.primary,
      borderColor: colors.primaryLight,
      borderWidth: 4,
      borderRadius: 12,
    },
    newGoalOption: {
      backgroundColor: 'transparent',
    },
    goalOptionText: {
      fontSize: globalScale * 16,
      color: colors.white,
    },
    newGoalOptionText: {
      color: isDarkMode ? colors.white : colors.primary,
    },
  };
};

export default getStyles;
